<div *ngIf="isLoading" class="loading-spinner">
  <mat-progress-spinner
    [color]="'primary'"
    [mode]="'indeterminate'"
    diameter="70"
  >
  </mat-progress-spinner>
</div>
<ng-container *ngIf="!isLoading && !!displayNode">
  <wk-info-drawer-layout
    [ngClass]="{ readOnly: !isEditMode }"
    [nodeInput]="displayNode"
    [title]="'APP.INFO_DRAWER.TITLE'"
    [(isEditMode)]="isEditMode"
    (infodrawerClosed)="closeInfodrawer()"
  >
    <adf-toolbar class="adf-toolbar--inline" info-drawer-buttons>
      <ng-container *ngFor="let entry of actions">
        <aca-toolbar-action
          [actionRef]="entry"
          [color]="getEntryColor(entry)"
        ></aca-toolbar-action>
      </ng-container>
    </adf-toolbar>

    <adf-info-drawer-tab
      *ngFor="let tab of tabs"
      [icon]="tab.icon"
      [label]="tab.title | translate"
    >
      <div *ngIf="tab.component === metadataComponent; else dynamicComponent">
        <mat-accordion *ngIf="isCompareMode">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'CORE.LEGENDS.TITLE' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="legends">
              <span class="inserted">
                {{ 'CORE.LEGENDS.INSERTED' | translate }}
              </span>
              <span class="deleted">
                {{ 'CORE.LEGENDS.DELETED' | translate }}
              </span>
              <span class="formatted">
                {{ 'CORE.LEGENDS.FORMATTED' | translate }}
              </span>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <adf-dynamic-component
          [data]="{ displayNode: displayNode, isEditMode: isEditMode }"
          [id]="tab.component"
        >
        </adf-dynamic-component>
        <mat-accordion>
          <mat-expansion-panel
            class="mat-mdc-card-content"
            *ngIf="!isNodeWorkingCopy"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'APP.INFO_DRAWER.VERSION_HISTORY' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <wk-version-list [node]="$any(displayNode)" [showActions]="false">
              </wk-version-list>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel class="mat-mdc-card-content">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'APP.INFO_DRAWER.TAGS' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <adf-tag-node-list [nodeId]="nodeId"> </adf-tag-node-list>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <ng-template #dynamicComponent>
        <adf-dynamic-tab
          [node]="$any(displayNode)"
          [id]="tab.component"
          [attr.data-automation-id]="tab.component"
        >
        </adf-dynamic-tab>
      </ng-template>
    </adf-info-drawer-tab>
  </wk-info-drawer-layout>
</ng-container>
